export type UuidVersion = 'v4' | 'v7';
export const DEFAULT_UUID_VERSION: UuidVersion = 'v4';

type Uuid = `${string}-${string}-${string}-${string}-${string}`;

export function isUuid(value: string): boolean {
	return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
}

export function randomUuid(version: UuidVersion = DEFAULT_UUID_VERSION): Uuid {
	return version === 'v4' ? generateUuidV4() : generateUuidV7();
}

function generateUuidV4(): Uuid {
	const bytes = secureRandomBytes();
	bytes[6] = (bytes[6]! & 0x0F) | 0x40;
	bytes[8] = (bytes[8]! & 0x3F) | 0x80;

	return formatUuid(bytes);
}

function generateUuidV7(): Uuid {
	const bytes = secureRandomBytes();
	let timestamp = Date.now();

	for (let index = 5; index >= 0; index--) {
		bytes[index] = timestamp % 256;
		timestamp = Math.floor(timestamp / 256);
	}

	bytes[6] = (bytes[6]! & 0x0F) | 0x70;
	bytes[8] = (bytes[8]! & 0x3F) | 0x80;

	return formatUuid(bytes);
}

function secureRandomBytes(): Uint8Array {
	return crypto.getRandomValues(new Uint8Array(16));
}

function formatUuid(bytes: Uint8Array): Uuid {
	const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
	return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
